import { Container } from '@material-ui/core'
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles'
import MUIDataTable from "mui-datatables"
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import { Link, useHistory } from 'react-router-dom'
import LoadingUI from '../../../components/ui/LoadingUI'
import PageTitle from '../../../components/ui/PageTitleUI'
import { useAuth } from '../../../hooks/auth'
import MvmApi from '../../../services/MvmApi'
import getDefaultGridOptions from '../../../utils/componentUtils'
import utilsDate from '../../../utils/Date'
import permissions from '../../../utils/Permissions'
import { FIASA_PLANT_ID } from '../../../utils/constants'
const PendingAccounting: React.FC = () => {
    const { t: _t } = useTranslation("General")
    const { t } = useTranslation("Mvm")
    const history = useHistory()
    const {user, hasPermission} = useAuth();

    const { isLoading, isFetching, data, refetch } = useQuery('pending', async () => {
        return await MvmApi.PendingAccountingMonitor(user.company.plantID);
    } ,{
        refetchOnWindowFocus: false,
        refetchOnMount: 'always',
        staleTime: 1000 * 60, //calculado em milisegundos - Propriedade para setar qto tempo o cache fica válido
        refetchInterval: 1000 * 60, //calculado em milisegundos - Propriedade para setar qto tempo vai buscar o cache novamente
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (!hasPermission(permissions.MVM.PendingAccount))
            history.replace('NoPermission');

            refetch();
    }, [history, user])

    const columns = [
            {
                name: 'mvmId',
                options: {
                    display: false,
                }
            },
            {
                name: 'mvcId',
                options: {
                    display: false,
                }
            },
            {
                name:  'mvmNumber',
                label: t("mvmNumber"),
                options: {
                    sort: false,
                    setCellHeaderProps: () => ({
                        align: "center",
                      }),
                    setCellProps: () => ({
                        align: "center"
                    }),
                    customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                        if (tableMeta.rowData[0] !== 0 ){
                            let mvmNumber = data.filter((element: { mvmId: any; }) => element.mvmId === tableMeta.rowData[0])[0].mvmNumber;
                            let accountingPendingResolutionUserName = data.filter((element: { mvmId: any; }) => element.mvmId === tableMeta.rowData[0])[0].accountingPendingResolutionUserName;
                        
                            return (
                                accountingPendingResolutionUserName === user.userName || accountingPendingResolutionUserName === null || accountingPendingResolutionUserName === "" ? <Link to={`/SubmitMvm/${tableMeta.rowData[0]}/viewPA`}>{mvmNumber}</Link> : mvmNumber
                            );
                        }else{
                            let mvcNumber = data.filter((element: { mvcId: any; }) => element.mvcId === tableMeta.rowData[1])[0].mvcNumber;
                            let accountingPendingResolutionUserName = data.filter((element: { mvcId: any; }) => element.mvcId === tableMeta.rowData[1])[0].accountingPendingResolutionUserName;

                            return (
                                accountingPendingResolutionUserName === user.userName || accountingPendingResolutionUserName === null? <Link to={`/SubmitMvc/${tableMeta.rowData[1]}/viewPA`}>{mvcNumber}</Link> : mvcNumber
                            );
                        }
                    }
                  }
            },{
                label: t("invoiceKey"),
                name: 'invoiceKey',
                options: {
                    sort: false,
                    setCellHeaderProps: () => ({
                        align: "center",
                      }),
                    setCellProps: () => ({
                        align: "center"
                    }),
                }
                
            },{
                label: t("invoiceNumber"),
                name: 'invoiceNumber',
                options: {
                    sort: false,
                    setCellHeaderProps: () => ({
                        align: "center",
                      }),
                    setCellProps: () => ({
                        align: "center"
                    })}
            },{
                label: t("supplier"),
                name:  'supplier',
                options: {
                    sort: false,
                    setCellHeaderProps: () => ({
                        align: "center",
                      }),
                    setCellProps: () => ({
                        align: "center"
                    })}
            },{
                label: _t("date"),
                name: 'invoiceDate',
                options: {
                    sort: false,
                    setCellHeaderProps: () => ({
                        align: "center",
                      }),
                    setCellProps: () => ({
                        align: "center"
                    }),
                    customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                        return utilsDate.DateTimeShort(value);
                    }
                }
            },{
                label: _t("category"),
                name: 'typeMvm',
                options: {
                    sort: false,
                    setCellHeaderProps: () => ({
                        align: "center",
                      }),
                    setCellProps: () => ({
                        align: "center"
                    }),
                    customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                        return <span>{value === 'S' ? t("jit") : t("kanban")}</span>;
                    }
                }
            },{
                label: t("companyCodeLegacy"),
                name: 'companyCodeLegacy',
                options: {
                    sort: false,
                    display: +user.company.plantID === FIASA_PLANT_ID,
                    setCellHeaderProps: () => ({
                        align: "center",
                      }),
                    setCellProps: () => ({
                        align: "center"
                    })
                }                
            },{
                label: _t("status"),
                name: 'statusDescription',
                options: {
                    sort: false,
                    setCellHeaderProps: () => ({
                        align: "center",
                      }),
                    setCellProps: () => ({
                        align: "center"
                    })
                }                
            },{
                label: t("blockUser"),
                name: 'accountingPendingResolutionUser',
                options: {
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    if (tableMeta.rowData[0] !== 0 ){
                        let item = data.filter((element: { mvmId: any; }) => element.mvmId === tableMeta.rowData[0])[0];
                        return item.accountingPendingResolutionUser ? `${item.accountingPendingResolutionUser}(${item.accountingPendingResolutionUserName})` : '';
                    } else {
                        let item = data.filter((element: { mvcId: any; }) => element.mvcId === tableMeta.rowData[1])[0];
                        return item.accountingPendingResolutionUser ? `${item.accountingPendingResolutionUser}(${item.accountingPendingResolutionUserName})` : '';                        
                    }
                }}
            }
    ]

    const myTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: ''                    
                }
            },
            MuiTableCell: {
                root: {
                    paddingLeft: 4,
                    paddingRight: 4,
                    paddingBottom: 10,
                    paddingTop: 10
                },
                head: {
                    height: 52
                }
            }
        }
    })

    return (
        <Container maxWidth={false} component="main">

            <PageTitle title={t("pendingAccountingTitle")} />

                <div style={{marginTop: "0.2rem", marginBottom: "0.3rem", display: "grid"}}>
                    <span style={{fontWeight:"bold",fontSize:"0.8rem"}}> {_t("lastUpdate") + utilsDate.TimeByCompleteDate(new Date())} </span>
                    <span>{_t("totalRecords") + (data ? data.length : 0)}</span>
                </div>
                
                    {
                        isLoading || isFetching ? <LoadingUI /> :
                            <MuiThemeProvider theme={myTheme}>
                                <MUIDataTable
                                    title=""
                                    data={data}
                                    columns={columns} 
                                    options={{
                                        ...getDefaultGridOptions(_t),
                                        serverSide: true,
                                        pagination: false,
                                        sort: false,
                                        selectToolbarPlacement: "none",
                                        filter: false,
                                        search: false,
                                        download: false,
                                        print: false,
                                        viewColumns: false,
                                        selectableRows: 'none',
                                       
                                    }}
                                    
                                />
                            </MuiThemeProvider>
                    }

        </Container>
    )
}
export default PendingAccounting;
